module.exports = __webpack_public_path__ + "img/handoffMetricsIcon.e1a8a23f.svg";